// @ts-strict-ignore
import { AssigneeInputBlock } from '@coast/schemas';
import moment from 'moment';
import { useEffect } from 'react';
import { useCardFormContext } from '../../contexts/form';
import { Fields } from '../../types';
import { useCreateCardTag } from '../inputTags/hooks';

export function useCreateBatchTagOnSubmit(block: AssigneeInputBlock) {
  const { registerPresubmitHook, unregisterPresubmitHook } = useCardFormContext();

  const createCardTag = useCreateCardTag(block.batchTagFieldName);
  useEffect(() => {
    registerPresubmitHook(block.name, async (values: Fields) => {
      if (!values.batchByAssignee || !values.assignees.length) {
        return;
      }
      const batchName = values.batchByAssigneeName ?? values.name;
      const tag = await createCardTag(`${batchName} (${moment().format('MMM Do, h:mm a')})`);
      return { [block.batchTagFieldName]: [tag.slug] };
    });
    return () => unregisterPresubmitHook(block.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block.name]);
}
